module.exports = __webpack_public_path__ + "media/site_templates/www.doorinstallation.company/images/about_us-87e56ed3371c2220792257def3fd25c2.jpg";